"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TelephoneBox = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _i18n = require("@ori/i18n");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _defaultTranslations = require("../../constants/defaultTranslations");
var _TranslationKey = require("../../models/TranslationKey");
var _TelephoneStyled = require("./TelephoneStyled");
var _jsxRuntime = require("react/jsx-runtime");
const TelephoneBox = props => {
  const {
    label,
    isVerified,
    connectWithWhatsApp
  } = props.option;
  const {
    canUpdate,
    option,
    onEdit,
    whatsUpEnabled,
    verification,
    isPrimary,
    canDeletePrimary,
    canSwitchPrimary,
    dataTestId,
    onVerify,
    isCheckoutSection
  } = props;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  let displayWhatsUpIcon = true;
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- we need logical operator
  const updatePrimaryTelephone = canDeletePrimary || whatsUpEnabled || !isVerified && verification;
  const updateAdditionalTelephone = canUpdate || whatsUpEnabled || !isVerified && verification || canSwitchPrimary;
  const verificationAlert = !isVerified && verification;
  const isEditable = (isPrimary ? updatePrimaryTelephone : updateAdditionalTelephone) && !isCheckoutSection;
  if (!whatsUpEnabled) {
    displayWhatsUpIcon = false;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TelephoneStyled.GridStyled, {
    container: true,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
      minWidth: "160px",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TelephoneStyled.TypographyContent, {
        variant: "body1",
        align: "left",
        "data-testid": getTestId(`${dataTestId}-input`),
        children: [label, displayWhatsUpIcon && connectWithWhatsApp ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.SocialIcon, {
          kind: "whatsapp",
          size: "small",
          sx: {
            fontSize: '28px'
          },
          "data-testid": getTestId(`${dataTestId}-whats-up-icon`)
        }) : null]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
      children: isEditable ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        component: "label",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
          variant: "text",
          color: "default",
          "data-testid": getTestId(`${dataTestId}-edit-button`),
          onClick: () => onEdit(option),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TelephoneStyled.PenIcon, {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.FormattedMessage, {
            id: _TranslationKey.TranslationKey.edit,
            defaultMessage: _defaultTranslations.defaultTranslations.edit
          })
        })]
      }) : null
    }), verificationAlert ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
      size: {
        xs: 12
      },
      sx: {
        marginTop: isCheckoutSection ? 1 : 0
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Alert, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
          sx: {
            display: 'flex'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
            component: "span",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.FormattedMessage, {
              id: _TranslationKey.TranslationKey.verifiedPhone,
              defaultMessage: _defaultTranslations.defaultTranslations.verifiedPhone
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
            onClick: () => onVerify?.(option),
            component: "button",
            variant: "body1",
            color: "inherit",
            sx: {
              marginLeft: 1
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.FormattedMessage, {
              id: _TranslationKey.TranslationKey.verifiedPhoneLink,
              defaultMessage: _defaultTranslations.defaultTranslations.verifiedPhoneLink
            })
          })]
        })
      })
    }) : null]
  });
};
exports.TelephoneBox = TelephoneBox;
//# sourceMappingURL=TelephoneBox.js.map